import { Calendario } from "../features/deals/Calendario/Calendario";

export function CalendarioContainer() {
    return (
        <div className="h-full w-full flex justify-center">
            <div className="h-full w-11/12">
                <Calendario />
            </div>
        </div>
    );
}
